module.exports = __webpack_public_path__ + "static/media/mustard green.5f7785e7.jpg";